/* Actions */
export const SET_SOURCE_CONTACTS_FILTERS = 'SET_SOURCE_CONTACTS_FILTERS';
export const setSourceContactsFilters = (filters: SourceContactsFilters) => ({
  type: SET_SOURCE_CONTACTS_FILTERS,
  payload: filters,
});

/* Initial States */
export interface SourceContactsFilters {
  [key: string]: any;
}

const initialState: SourceContactsFilters = {};

interface Action {
  type: string;
  payload: SourceContactsFilters;
}

/* Reducers */
export const sourceContactsFiltersReducer = (state = initialState, action: Action) => {
  switch (action.type) {
    case SET_SOURCE_CONTACTS_FILTERS:
      return { ...action.payload };

    default:
      return state;
  }
};
